import { OnInit } from '@angular/core';
import { Route } from 'src/app/models/route';
import { Location } from '@angular/common';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouteService } from 'src/app/services/routes/route.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Profile } from 'src/app/models/profile';
import { TruckService } from 'src/app/services/truck/truck.service';
import { Truck } from 'src/app/models/truck';
import { PROFILE_TYPE } from 'src/app/constants';

export class RouteFoundPage implements OnInit {

  route: Route;
  user: Profile;
  token: string;

  trucksFleetBooklet: Truck[] = [];

  constructor(
    protected location: Location,
    protected spinner: SpinnerService,
    protected auth: AuthService,
    protected profile: ProfileService,
    protected routeService: RouteService,
    protected alert: AlertService,
    protected router: Router,
    protected truckService: TruckService,
    protected activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    const routeId = this.activatedRoute.snapshot.paramMap.get('routeId');

    if (routeId) {
      this.getRouteDetail(routeId);
    } else {
      this.route = this.location.getState() as Route;
    }

    if (this.route && this.isProfessionalRouteOwner()) { 
      this.getRouteOwnerTrucks();
    }
  }

  async getRouteDetail(id: string) {
    let token: string;

    try {
      token = (await this.profile.getProfile()) && (await this.auth.getToken());
    } catch (err) {}

    try {
      await this.spinner.show();
      this.route = await this.routeService.get(token, id);
      await this.spinner.dismiss();
    } catch (err) {
      const { status } = err;

      if (status === 404) {
        await this.spinner.dismiss();
        return this.alert.redirect(['/tabs/discover-send'], '', 'ROUTE_CANCELLED');
      }
      
      await this.spinner.dismissWithAlertError(err);
    }
  }

  async verifyMatch() {
    const { id } = this.route;
    if (!id) { return; }

    try {
      await this.spinner.show();
      this.token = await this.auth.getToken();
      if (!this.token) {
        throw new Error()
      }
    } catch (error) {
      await this.spinner.dismiss();
      await this.alert.showAlertEnterSignup();
      return;
    }

    try {
      this.user = await this.profile.getProfile();
      if (!this.user) {
        throw new Error()
      }
      await this.spinner.dismiss();
    } catch (error) {
      await this.spinner.dismiss();
      await this.alert.redirect(['/profile'], null, 'GUARD_PROFILE');
      return;
    }

    this.execMatch(id)
  }

  async execMatch(id: number) {
    try {
      await this.spinner.show();
      const travel = await this.routeService.match(this.token, id) || {};

      await this.spinner.dismiss();

      await this.router.navigate([`/route-detail/${travel.route.id}`], { replaceUrl: true , skipLocationChange: true });
      await this.router.navigate([`/chat/${travel.id}`]);

    } catch (err) {
      console.log('error', err)
      const { status } = err;

      /* Se è un errore nel match, cerco se ho già fatto match precedentemente e lo mando alla chat */
      if (status === 400) {
        try {
          const route = await this.routeService.get(this.token, this.route.id);
          const { travels = [] } = route;
          const travel = travels.find(t => t.actor && t.actor.id === this.user.id);
          if (travel && travel.id) {
            await this.spinner.dismiss();
            await this.router.navigate([`/route-detail/${this.route.id}`], { replaceUrl: true , skipLocationChange: true });
            await this.router.navigate([`/chat/${travel.id}`]);
            return;
          }
        } catch (e) {
        }
      }

      this.spinner.dismissWithAlertError(err);
    }
  }

  isProfessionalRouteOwner() {
    const { owner = {} as Profile } = this.route || {};
    const { type = '' } = owner || {};
    return type === PROFILE_TYPE.professional;
  }

  async getRouteOwnerTrucks() {
    try { 
      this.token = await this.auth.getToken();
      this.user = await this.profile.getProfile();
      if (!this.token || !this.user) {
        throw new Error()
      }
    } catch(error) {
      return;
    }

    try {
      if (this.token) {
        if (this.route.owner.id) {
          const id = this.route.owner.id;
          const body = await this.truckService.getRouteOwnerTrucks(this.token, id);
          this.trucksFleetBooklet = body;
        }
      }
    } catch (error) {
      await this.alert.showAlertEnterSignup();
      return;
    }
  }
}
